import { getReplacedAttributeValue } from '../../../services/selections';

export const getters = {
    getSearchText: state => state.searchText,
    getSearchResults: state => state.searchResults,
    getUserSearches: state => {
        if (!state.userSearches?.length > 0) {
            return null;
        }
        return [...state.userSearches].sort((a, b) => b.content.lastDate - a.content.lastDate);
    },
    getObjectDataSelectedGroupIndex: state => {
        return state.selectedObjectDataGroupIndex;
    },
    getObjectDataSelectedItemIndex: state => {
        return state.selectedObjectDataItemIndex;
    },
    getObjectDataSelectedItem: (state) => (groupIndex, itemIndex) => {
        const objectsInGroup = state.objectSearchResults[groupIndex];
        const item = objectsInGroup.data.items[itemIndex];
        const feature = objectsInGroup.data.features?.[itemIndex];
        const info = objectsInGroup.data.fields.map((field, _index) => {
            const value = item[field.key];
            const hyperlink = field.hyperlink ?? false;
            const hyperlinkText = field.hyperlinkText && value ? getReplacedAttributeValue(field.hyperlinkText, value) : '';

            let displayValue = value;
            if (hyperlink && field.hyperlinkExpression) {
                displayValue = displayValue ? getReplacedAttributeValue(field.hyperlinkExpression, displayValue) : '';
            }

            return {
                attribute: field.key,
                alias: field.label,
                order: _index,
                displayInTable: true,
                displayInDetail: field.displayInDetail ?? true,
                popup: field.popup ?? true,
                exportable: true,
                print: true,
                value,
                displayValue,
                hyperlink,
                hyperlinkText,
                hyperlinkImage: field.hyperlinkImage,
                openExtern: field.openExtern,
                media: {
                    isPhoto: false
                }
            };
        }).filter(({ displayInDetail }) => displayInDetail);

        return {
            type: 'api',
            nedGlobeRowId: item.nedGlobeRowId,
            title: objectsInGroup.title,
            info,
            item,
            feature,
            rowClick: objectsInGroup.data.rowClick,
            groupIndex,
            itemIndex
        };
    },
    getTableSearchResultById: (state) => (id) => {
        return state.tableSearchResults.find(result => result.id === id);
    },
    getTableSearchResultByTablename: (state) => (tableName) => {
        return state.tableSearchResults.find(result => result.tableName === tableName);
    },
    // Place to keep the last open tab.
    // If this has a value tabs.vue will focus on the last tab when a tab isbeing added.
    getTabToFocus: state => state.tabToFocus
};
